export default __webpack_public_path__ + "static/media/create.b3b1b1a9.jpg";